
/**
 * Generates a random voucher code of specified length.
 * The characters are chosen to be easily readable and avoid confusion
 * (excludes similar looking characters like 0, O, 1, I, etc).
 * @param length The length of the voucher code to generate (default: 8)
 * @returns A randomly generated voucher code
 */
export const generateVoucherCode = (length = 8): string => {
  const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

/**
 * Batches an array into chunks of specified size
 * @param array The array to batch
 * @param batchSize The size of each batch
 * @returns An array of arrays, each containing at most batchSize elements
 */
export const batchArray = <T>(array: T[], batchSize: number): T[][] => {
  const batches: T[][] = [];
  for (let i = 0; i < array.length; i += batchSize) {
    batches.push(array.slice(i, i + batchSize));
  }
  return batches;
};

/**
 * Formats a date as a string in the local date format
 * @param date The date to format, can be a Date object or ISO string
 * @returns A formatted date string
 */
export const formatDate = (date: Date | string): string => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString();
};

/**
 * Checks if a campaign is active based on its start and end dates
 * @param startDate The campaign start date
 * @param endDate The campaign end date
 * @returns An object with isActive, isUpcoming, and isExpired flags
 */
export const getCampaignDateStatus = (startDate: Date | string, endDate: Date | string) => {
  const start = typeof startDate === 'string' ? new Date(startDate) : startDate;
  const end = typeof endDate === 'string' ? new Date(endDate) : endDate;
  const now = new Date();
  
  return {
    isActive: start <= now && end >= now,
    isUpcoming: start > now,
    isExpired: end < now
  };
};
